export interface IAssessmentQuestion {
  title: string;
  questionNumber: string;
  questionTitle: string;
  category: string;
  subCategory: string;
  note: string;
  percent: number;
  compensatingOverrideScore: number;
  complianceOverrideScore: number;
  checklistId: number;
  checklistItemId: number;
}

export enum AssessmentAnswerType {
  "COMPLIANCE" = "Compliance",
  "COMPENSATING" = "Compensating",
}

export interface IAssessmentQuestionOverride {
  compensatingType?: string;
  defaultComplianceScore?: number;
  complianceOverrideScore?: number | null;
  compensatingOverrideScore?: number | null;
  note?: string;
}

export interface IAssessmentQuestionFile {
  id: number;
  name: string;
  size: number;
  type: string;
  date: Date;
  uploadedBy: {
    nameText: string;
    email: string;
  };
  addedByUserId: string;
}
